import React, { Component, Fragment } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Spinner,
} from "reactstrap";
import Footer from "../partials/Footer";
import Header from "../partials/Header";
import cart from "../../assets/imgs/emptyCart.png";
import bgCart from "../../assets/imgs/bg_empty_cart.png";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  addGameToCard,
  addGameToUserFav,
  fetchGames,
  removeGameFromCard,
  removeGameFromUserFav,
} from "../../redux/actions/gameActions";
import moment from "moment";

export class Cart extends Component {
  total = 0;
  componentDidMount() {
    this.props.fetchGames();
  }
  isItemInCart = (id) => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) {
      let exist = cart.find((item) => item == id);
      if (exist) return true;
    }
    return false;
  };

  noOfItemsInCart = () => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) return cart.length;
    return 0;
  };
  isItemInFav = (id) => {
    let user = JSON.parse(localStorage.getItem("user_info"));
    if (user != null) {
      let exist =
        user.my_favourites && user.my_favourites.find((item) => item == id);
      if (exist) return true;
    }
    return false;
  };
  getGamesInCart = () => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    let { game } = this.props;
    let gamesInCart = -1;

    if (game.games != -1 && game.games != null && cart != null) {
      gamesInCart = [];
      this.total = 0;
      for (let cartItem of cart) {
        console.log(cartItem, cart, game.games);
        let obj = game.games.find((game) => game.id == cartItem);
        console.log(obj);
        if (obj != null) gamesInCart.push(obj);
        this.total += obj.price;
      }
    }
    return gamesInCart;
  };
  customAddToCart = (id) => {
    let obj = JSON.parse(localStorage.getItem("cart"));
    if (obj == null) {
      obj = [];
    }
    let exist = obj.find((item) => item == id);
    if (!exist) obj.push(id);
    localStorage.setItem("cart", JSON.stringify(obj));
  };

  render() {
    console.log(this.getGamesInCart(), this.props.game.games);
    return (
      <Fragment>
        <Header {...this.props} path={["Home", "Cart"]} heading="Cart" />
        {this.noOfItemsInCart() != 0 ? (
          <Container className="bg-purple-4 margin-top-fix games-cart-container mb-5">
            {/* Cart Item */}
            {this.getGamesInCart() == -1 ? (
              <div className="d-flex align-items-center justify-content-center my-5">
                <Spinner color="light" />
              </div>
            ) : (
              this.getGamesInCart().map((game) => {
                <hr
                  className="text-purple-1 mt-5 mx-3 mx-sm-0"
                  style={{ height: 3 }}
                />;
                return (
                  <Row className="justify-content-center align-items-end ">
                    <Col xl={4} lg={4} md={10} sm={12}>
                      <div
                        className="games-cart-img cart-game-img-1"
                        style={{ backgroundImage: `url(${game.img})` }}
                      ></div>
                    </Col>
                    <Col lg={8} md={10} xs={11}>
                      <Row className="justify-content-between text-white-1 mt-3">
                        <Col sm={8} xs={12}>
                          <div className="text-start">
                            <CardTitle tag="h5">{game.title}</CardTitle>
                          </div>
                        </Col>
                        <Col md={3} sm={3} xs={5}>
                          <div className="text-center">
                            <CardSubtitle className="text-muted ">
                              {moment(game.start_time).format("DD MMM YYYY")}
                            </CardSubtitle>
                          </div>
                        </Col>
                        <Col sm={1} xs={3}>
                          <div className="text-end">
                            <CardSubtitle>Price</CardSubtitle>
                          </div>
                        </Col>
                      </Row>
                      <Row className="justify-content-between text-white-1 mt-3">
                        <Col sm={6} xs={7}>
                          <div className="text-start">
                            <CardSubtitle className="">
                              {game.address}
                            </CardSubtitle>
                          </div>
                        </Col>
                        <Col sm={2} xs={3}>
                          <div className="text-end">
                            <CardTitle tag="h5">
                              <b>{game.price} $</b>
                            </CardTitle>
                          </div>
                        </Col>
                      </Row>
                      <Col md={8}>
                        <CardSubtitle
                          tag="h6"
                          className="mb-2 text-lightpurple-1 mt-3"
                          style={{ lineHeight: 1.5 }}
                        >
                          About : Lorem ipsum dolor sit amet, consectetur
                          adipiscing elit. Nibh quam dui sagittis dignissim ut
                          at quis. Tortor est .....
                        </CardSubtitle>
                      </Col>
                      <Row className="justify-content-between align-items-end mt-2 mt-xl-5">
                        <Col xl={4} lg={5} sm={6} xs={7}>
                          {this.props.game.addGameToUserFav &&
                          this.props.game.addGameToUserFav == -1 ? (
                            <Spinner color="light" size="sm" />
                          ) : !this.isItemInFav(game.id) ? (
                            <Button
                              className="bg-purple-2 mt-5 mt-xl-0 px-3 ms-auto"
                              onClick={(e) => {
                                this.props.addGameToUserFav(game.id);
                              }}
                              style={{
                                borderRadius: 10,
                                border: "1px solid #dc6e6f",
                              }}
                            >
                              <i className="far fa-heart px-1 text-red-1"></i>
                              <span className="px-1 text-white-1 btn-font">
                                Add To Favorite
                              </span>
                            </Button>
                          ) : (
                            <Button
                              className="bg-purple-2 mt-5 mt-xl-0 btn-sm ms-auto"
                              onClick={(e) => {
                                this.props.removeGameFromUserFav(game.id);
                              }}
                              style={{
                                borderRadius: 10,
                                border: "1px solid #dc6e6f",
                              }}
                            >
                              <i className="fa fa-heart px-1 text-red-1"></i>
                              <span className="px-1 text-white-1 btn-font">
                                Remove From Favorite
                              </span>
                            </Button>
                          )}
                        </Col>
                        <Col lg={3} sm={4} xs={5}>
                          <div className="text-end">
                            <Button
                              className="bg-purple-2 mt-5 mt-xl-0 px-3 ms-auto"
                              onClick={(e) => {
                                this.props.removeGameFromCart(game.id);
                              }}
                              style={{
                                borderRadius: 10,
                                border: "1px solid #FFC144",
                              }}
                            >
                              <i className="fas fa-trash px-1 text-yellow-2"></i>
                              <span className="px-1 text-white-1 btn-font">
                                Remove
                              </span>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                );
              })
            )}
            <Row className="justify-content-end px-4 px-lg-0 mt-5">
              <Col sm={2} xs={3}>
                <div className="text-end text-white-1">
                  <h5>Total : </h5>
                </div>
              </Col>
              <Col lg={1} sm={2} xs={3}>
                <div className="text-center">
                  <h5 className="text-red-1">{this.total} $</h5>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-end px-4 px-lg-0">
              <Col lg={4} md={5} sm={6}>
                <Button
                  className="bg-dark-3 w-100 text-white-1 mt-5 py-3"
                  style={{ borderRadius: 10, border: "none" }}
                >
                  <span className="text-lightpurple-1">
                    Add Discount Coupon
                  </span>
                </Button>
              </Col>
              <Col lg={4} md={5} sm={6}>
                <Button
                  className="bg-purple-3 w-100 text-white-1 mt-5 px-4 py-3"
                  style={{ borderRadius: 10, border: "none" }}
                >
                  <b className="px-2">Add Coupon</b>
                </Button>
              </Col>
            </Row>
            <Row className="justify-content-end px-4 px-lg-0">
              <Col lg={4} md={5} sm={6}>
                <Button
                  className="bg-dark-3 w-100 text-white-1 mt-5 py-3"
                  style={{ borderRadius: 10, border: "none" }}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push("/games");
                  }}
                >
                  <span>Continue Shopping</span>
                </Button>
              </Col>
              <Col lg={4} md={5} sm={6}>
                <Link
                  to="/pay-purchase"
                  className="btn bg-purple-3 w-100 text-white-1 mt-5 px-4 py-3 mb-3"
                  style={{ borderRadius: 10, border: "none" }}
                >
                  <b className="px-2">Process To Checkout</b>
                </Link>
              </Col>
            </Row>
          </Container>
        ) : (
          <Container className="bg-purple-4 margin-top-fix empty-cart-container mb-5">
            <div className="text-center text-white-1">
              <div className="empty-cart">
                <div className="empty-cart-img-1"></div>
              </div>
              {/* <img src={bgCart} alt="" className="empty-cart" />
                        <img src={cart} alt="" className="empty-cart-img-1" /> */}
              <h2 className="mt-5">Your Cart Is Empty!</h2>
              <h5 className="mt-3">
                Browse Our Events And Discover Our Best Games !
              </h5>
              <Link
                to="/"
                className="btn bg-purple-1 mt-3 px-5 py-3"
                style={{ borderRadius: 10, border: "none" }}
              >
                <span className="text-white-1">Start Shopping</span>
              </Link>
            </div>
          </Container>
        )}
        <Container>
          <h4 className="text-white-1">Recently viewed Events</h4>
          <Row className="mb-5 mt-3">
            {this.props.game.games && this.props.game.games.length
              ? this.props.game.games.slice(0, 4).map((game) => {
                  return (
                    <Col
                      key={`GameCard${game.id}`}
                      xl={3}
                      lg={6}
                      md={6}
                      sm={6}
                      className="mt-4"
                    >
                      <Link
                        className="text-decoration-none"
                        to={"/event-purchase/" + game.id}
                        // to={{ pathname: "/event-purchase", state: game.id }}
                      >
                        <Card className="bg-dark-1 text-white-1 game-card">
                          <div
                            className="game-img game-img-1"
                            style={{ backgroundImage: `url(${game.img})` }}
                          ></div>
                          <CardBody>
                            <CardTitle tag="h6">{game.title}</CardTitle>
                            <CardSubtitle
                              tag="h6"
                              className="mb-2 text-muted mt-3"
                            >
                              {game.address}
                            </CardSubtitle>
                            <CardSubtitle
                              tag="h6"
                              className="mb-2 text-muted mt-3"
                            >
                              {moment(game.start_date.toDate()).format(
                                "DD MMM YYYY"
                              )}
                            </CardSubtitle>
                            <div className="d-flex mt-3">
                              <p className="mt-1">Price:</p>
                              <p className="px-2 mt-1 text-green-1">
                                ${game.price}
                              </p>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.isItemInCart(game.id)
                                    ? this.props.removeGameFromCart(game.id)
                                    : // this.customAddToCart(game.id);
                                      this.props.addGameToCart(game.id);
                                }}
                                className="ms-auto text-white-1 px-4 bg-dark-4 btn-join"
                              >
                                {this.isItemInCart(game.id)
                                  ? "Remove"
                                  : "Join Now"}
                              </button>
                            </div>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                  );
                })
              : null}
            {/* <Col xl={3} lg={6} md={6} sm={6} className="mt-4">
              <Card className="bg-dark-1 text-white-1 game-card">
                <div className="game-img game-img-1"></div>
                <CardBody>
                  <CardTitle tag="h6">
                    The Results Are Now - Call of Duty
                  </CardTitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    San Francisco, mond...
                  </CardSubtitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    29 Augh 2021
                  </CardSubtitle>
                  <div className="d-flex mt-3">
                    <p className="mt-1">Price:</p>
                    <p className="px-2 mt-1 text-green-1">$60</p>
                    <button className="ms-auto text-white-1 px-4 bg-dark-4 btn-join">
                      Join Now
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} lg={6} md={6} sm={6} className="mt-4">
              <Card className="bg-dark-1 text-white-1 game-card">
                <div className="game-img game-img-2"></div>
                <CardBody>
                  <CardTitle tag="h6">
                    The Results Are Now - Call of Duty
                  </CardTitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    San Francisco, mond...
                  </CardSubtitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    29 Augh 2021
                  </CardSubtitle>
                  <div className="d-flex mt-3">
                    <p className="mt-1">Price:</p>
                    <p className="px-2 mt-1 text-green-1">$60</p>
                    <button className="ms-auto text-white-1 px-4 bg-dark-4 btn-join">
                      Join Now
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} lg={6} md={6} sm={6} className="mt-4">
              <Card className="bg-dark-1 text-white-1 game-card">
                <div className="game-img game-img-3"></div>
                <CardBody>
                  <CardTitle tag="h6">
                    The Results Are Now - Call of Duty
                  </CardTitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    San Francisco, mond...
                  </CardSubtitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    29 Augh 2021
                  </CardSubtitle>
                  <div className="d-flex mt-3">
                    <p className="mt-1">Price:</p>
                    <p className="px-2 mt-1 text-green-1">$60</p>
                    <button className="ms-auto text-white-1 px-4 bg-dark-4 btn-join">
                      Join Now
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} lg={6} md={6} sm={6} className="mt-4">
              <Card className="bg-dark-1 text-white-1 game-card">
                <div className="game-img game-img-4"></div>
                <CardBody>
                  <CardTitle tag="h6">
                    The Results Are Now - Call of Duty
                  </CardTitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    San Francisco, mond...
                  </CardSubtitle>
                  <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">
                    29 Augh 2021
                  </CardSubtitle>
                  <div className="d-flex mt-3">
                    <p className="mt-1">Price:</p>
                    <p className="px-2 mt-1 text-green-1">$60</p>
                    <button className="ms-auto text-white-1 px-4 bg-dark-4 btn-join">
                      Join Now
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col> */}
          </Row>
        </Container>
        <Footer />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    game: state.game,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchGames: () => dispatch(fetchGames()),
    addGameToCart: (id) => dispatch(addGameToCard(id)),
    removeGameFromCart: (id) => dispatch(removeGameFromCard(id)),
    addGameToUserFav: (id) => dispatch(addGameToUserFav(id)),
    removeGameFromUserFav: (id) => dispatch(removeGameFromUserFav(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Cart);
